import api from './client';

export async function stopMockLogin(sessionId: string) {
  const { data } = await api.post(`/mock-login/${sessionId}/stop`);
  return data;
}
